if (typeof document === "undefined") return;
var extractCssCreateStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject, fetchPriority
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;



	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var extractCssFindStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var extractCssLoadStylesheet = function (chunkId, fetchPriority) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (extractCssFindStylesheet(href, fullhref)) return resolve();
		extractCssCreateStylesheet(chunkId, fullhref, null, resolve, reject, fetchPriority);
	})
}

// no chunk loading
var extractCssOldTags = [];
var extractCssNewTags = [];
var extractCssApplyHandler = function (options) {
	return {
		dispose: function () {},
		apply: function () {
			for (var i = 0; i < extractCssNewTags.length; i++) extractCssNewTags[i].sheet.disabled = false;
			for (var i = 0; i < extractCssOldTags.length; i++) {
				var oldTag = extractCssOldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			extractCssOldTags.length = 0;
			extractCssNewTags.length = 0;
		}
	}
}
var extractCssInitialChunkIds = {"index": 1,"lib-react": 1,"vendors-node_modules_react-datepicker_dist_react-datepicker_css-node_modules_react-image-gall-fff1a5": 1,};
// A chunk is present on this page only when the active JavaScript
// chunk-loading runtime records it as fully loaded.
var extractCssChunkIsLoaded = function (chunkId) {
	return typeof __webpack_require__.hmrS_jsonp !== "undefined" && __webpack_require__.hmrS_jsonp && __webpack_require__.hmrS_jsonp[chunkId] === 0;
};
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList, css, miniCss) {
	applyHandlers.push(extractCssApplyHandler);
	/**
		`miniCss` is the hot-update manifest's namespace for extracted CSS:
		`miniCss.c` lists the chunks whose extracted CSS content actually changed
		and `miniCss.r` the chunks whose extracted CSS disappeared. It is kept
		apart from the native css runtime's `css` namespace so neither runtime
		reacts to the other's stylesheets. Its absence means this update carries
		no extracted CSS work at all — notably the runtime chunk is in `chunkIds`
		on every update (its full hash always changes) while its stylesheet
		rarely does.
	 */
	var cssRemovedChunkIds = (miniCss && miniCss.r) || [];
	var cssChunkIds = (miniCss && miniCss.c) || [];
	var seen = {};
	cssRemovedChunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		if (!href) return;
		var oldTag = extractCssFindStylesheet(href, __webpack_require__.p + href);
		if (oldTag) extractCssOldTags.push(oldTag);
	});
	cssChunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		if (!href) return;
		var fullhref = __webpack_require__.p + href;
		if (seen[fullhref]) return;
		seen[fullhref] = true;
		var oldTag = extractCssFindStylesheet(href, fullhref);
		// The manifest is computed from the compilation and also lists chunks this
		// page never loaded. A missing tag is legitimate only for a chunk that is
		// actually on the page: an initial chunk gaining its first stylesheet, or
		// a loaded async chunk whose stylesheet was removed by an earlier update.
		if (!oldTag && !extractCssInitialChunkIds[chunkId] && !extractCssChunkIsLoaded(chunkId)) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = extractCssCreateStylesheet(
				chunkId,

				/**
					Use a query to bypass the browser cache: with an existing link the
					browser may treat the new tag as the same resource and skip fetching
					(this can happen during lazy compilation, same strategy as the
					updateCss API), and even without a current link the stable filename
					may still be cached from before the stylesheet was removed.
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.sheet.disabled = true;
					if (oldTag) extractCssOldTags.push(oldTag);
					extractCssNewTags.push(tag);
					resolve();
				},
				reject
			);
		}))
	});
}

// no prefetch
// no preload